import React, { Fragment } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import useCart from 'store/CartProvider'
import useProduct from 'store/SingleProductProvider'
import { useSelectedColor } from 'store/SelectedColorProvider'

import {
  StorageStatusContainer,
  ProductPrice as StyledProductPrice,
} from './MainInfo/MainInfo.style'
import {
  calculateCitrusCashback,
  calculateCitrusCashbackAmount,
  calculateCredoCashback,
  calculateCredoCashbackAmount,
  canCitrusCashback,
  canCredoCashback,
  canTbcConceptCashback,
  calculateTbcConceptCashback,
  isInSale,
  percentageSaleCalculator,
} from 'consts'
import {
  SalePercentage,
  CardContainer,
  ColorOption,
} from '../ProductItem/ProductItem.style'
import { BrowserView, MobileView } from 'components/DeviceDetect'
import NoStock from 'components/Icons/NoStock'
import ClockCircle from 'components/Icons/ClockCircle'
import Stock from 'components/Icons/Stock'

export default function ProducPrice(props) {
  const { product, productPrice, productOldPrice, installmentPrice, inStock } =
    useProduct()
  const { payMethod, bank } = useCart()
  const { selectedColor, setSelectedColor } = useSelectedColor()

  // const colors = Array.from(
  //   new Set(
  //     product.images
  //       .filter(img => img.color_id !== null)
  //       .map(img => img.color_name)
  //   )
  // )
  // const colorOptions = colors.length > 0 ? ['#ccc', ...colors] : []
  const colorImages = product.images.filter(img => img.color_id !== null)

  const colors = Array.from(new Set(colorImages.map(img => img.color_name)))

  const showColorOptions = colors.length > 0

  const history = useHistory()
  const location = useLocation()

  const { old_price, stock_status } = product
  const hidePriceOnInstallment =
    props.hidePriceOnInstallment && payMethod === 'installment'

  const productSku = product?.sku || null

  return (
    <StyledProductPrice
      itemProp="offers"
      itemScope
      itemType="https://schema.org/Offer"
      style={
        props.Browser
          ? {
              borderBottom: '1px solid #E5E5E5',
              paddingBottom: ' 20px',
              marginBottom: '-20px',
            }
          : {}
      }
    >
      {inStock && (
        <div>
          <div style={{ position: 'relative' }}>
            <h4>ფასი:</h4>
            {isInSale(productOldPrice, productPrice) ? (
              <SalePercentage productItem={false}>
                -{percentageSaleCalculator(productOldPrice, productPrice)}%
              </SalePercentage>
            ) : null}
          </div>
        </div>
      )}
      <h2>
        {inStock && !hidePriceOnInstallment && (
          <span className="saled">
            <span className="priceMain" itemProp="price" content={productPrice}>
              {productPrice}
            </span>
            <span className="balls" itemProp="priceCurrency" content="GEL">
              ₾
            </span>
            <link itemProp="availability" href="https://schema.org/InStock" />
          </span>
        )}
        {!inStock && (
          <Fragment>
            <link
              itemProp="availability"
              href="https://schema.org/OutOfStock"
            />
          </Fragment>
        )}
        {old_price && inStock ? (
          <span className="original">
            <span className="price">{old_price}₾</span>
          </span>
        ) : null}
      </h2>
      {/* Credo price edit */}
      {inStock && canCredoCashback(productPrice) ? (
        <div className="credo-bank-card-in-product">
          <h4 className="credo-bank-akcia">აქცია!</h4>
          <h4>Credo ბანკის Mastercard ბარათით გადახდის შემთხვევაში:</h4>

          <h2>
            {inStock && !hidePriceOnInstallment && (
              <span className="saled flex">
                <span
                  className="priceMain"
                  itemProp="price"
                  content={productPrice}
                >
                  {calculateCredoCashback(productPrice)}
                </span>
                <span className="balls" itemProp="priceCurrency" content="GEL">
                  ₾
                </span>
              </span>
            )}
            {inStock ? (
              <span className="original">
                <span className="price">{productPrice}₾</span>
              </span>
            ) : null}

            <span className="saled flex pl-4 !text-[30px]">
              <span
                className="priceMain"
                itemProp="price"
                content={productPrice}
              >
                -{calculateCredoCashbackAmount(productPrice)}
              </span>
              <span className="balls" itemProp="priceCurrency" content="GEL">
                ₾
              </span>
            </span>
          </h2>
          <div className="w-full text-center">
            <img
              className="w-[150px]"
              src="/img/credo-mastercardpng.png"
              alt="Credo mastercard citrus sale"
            />
          </div>
        </div>
      ) : null}
      {inStock && canCitrusCashback(productPrice, payMethod) ? (
        <div className="credo-bank-card-in-product">
          <h4 className="credo-bank-akcia">აქცია!</h4>
          <h4>Citrus.ge - ის ქეშბექის აქციის ფარგლებში</h4>
          <h5>ნებისმიერი ბარათით გადახდის შემთხვევაში:</h5>

          <h2>
            {inStock && !hidePriceOnInstallment && (
              <span className="saled flex">
                <span
                  className="priceMain"
                  itemProp="price"
                  content={productPrice}
                >
                  {calculateCitrusCashback(productPrice)}
                </span>
                <span className="balls" itemProp="priceCurrency" content="GEL">
                  ₾
                </span>
              </span>
            )}
            {inStock ? (
              <span className="original">
                <span className="price">{productPrice}₾</span>
              </span>
            ) : null}

            <span className="saled flex pl-4 !text-[30px]">
              <span
                className="priceMain"
                itemProp="price"
                content={productPrice}
              >
                -{calculateCitrusCashbackAmount(productPrice)}
              </span>
              <span className="balls" itemProp="priceCurrency" content="GEL">
                ₾
              </span>
            </span>
          </h2>
          <div className="w-full text-center flex flex-row gap-4 justify-center">
            <img
              className="w-[130px]"
              src="/img/logo.png"
              alt="Credo mastercard citrus sale"
            />

            <img
              className="w-[90px] h-[40px] object-contain"
              src="/img/logo-visa-mastercard.png"
              alt="Citrus visa mastercard cashback citrus cashback"
            />
          </div>
        </div>
      ) : null}

      {inStock && canTbcConceptCashback(productPrice, payMethod, bank) ? (
        <div className="credo-bank-card-in-product">
          <h4 className="credo-bank-akcia">აქცია!</h4>
          <h4 style={{ fontWeight: 900 }}>
            ახალი თიბისი ბარათით გადახდის შემთხვევაში:
          </h4>
          <h5>ქეშბექი 30% მაქსიმუმ 100 ლარი</h5>

          <h2 style={{ margin: '10px auto', position: 'relative' }}>
            <img
              className="h-[40px] object-contain"
              src="/img/tbc_geo.png"
              alt="TBC concept cashback"
              style={{ marginRight: '30px' }}
            />
            <span
              style={{
                fontWeight: 700,
                fontSize: '14px',
                position: 'absolute',
                marginLeft: '80px',
              }}
            >
              ქეშბექი:
            </span>

            <span className="saled flex pl-4 !text-[30px]">
              <span
                className="priceMain"
                itemProp="price"
                content={productPrice}
                style={{ color: 'black' }}
              >
                {calculateTbcConceptCashback(productPrice)}
              </span>
              <span
                className="balls"
                itemProp="priceCurrency"
                content="GEL"
                style={{ color: 'black' }}
              >
                ₾
              </span>
            </span>
          </h2>
          {/* <div className="w-full text-center flex flex-row gap-4 justify-center">
            <img
              className="w-[90px] h-[40px] object-contain"
              src="/img/tbc_card.png"
              alt="TBC concept cashback"
            />
          </div> */}
        </div>
      ) : null}
      {/* End credo price edit */}
      {installmentPrice && inStock ? (
        <h3>
          განვადებით <span>{installmentPrice}₾</span> თვეში
        </h3>
      ) : null}

      {showColorOptions && (
        <div>
          <h1 className="text-sm text-gray-600 mt-4">
            <span className="text-slate-600">ფერი:</span>
            <span className="font-semibold capitalize ml-1 text-[#333333]">
              {selectedColor}
            </span>
          </h1>
          <div className="flex gap-3 flex-wrap mt-3 mb-4">
            {colors.map(color => {
              const isActive = selectedColor === color

              const handleClick = () => {
                setSelectedColor(color, productSku)

                const params = new URLSearchParams(location.search)

                params.set('color', color)
                params.set('product', productSku)

                history.replace({
                  pathname: location.pathname,
                  search: params.toString(),
                })
              }

              return (
                <>
                  <ColorOption
                    key={color}
                    color={color}
                    isActive={isActive}
                    onClick={handleClick}
                  />
                </>
              )
            })}
          </div>
        </div>
      )}

      <MobileView>
        <StorageStatusContainer>
          {inStock ? null : (
            <span className="out-of-stock">
              <NoStock />
              არ არის მარაგში
            </span>
          )}
          {1 === stock_status && (
            <span className="in-stock">
              <Stock />
              მარაგშია
            </span>
          )}
          {3 === stock_status && (
            <span className="in-stock blue-background">
              <Stock color="#ffffff" />
              მარაგშია
            </span>
          )}
          {2 === stock_status && (
            <span className="check-amount-stock">
              <ClockCircle size={20} />
              მარაგი გადასამოწმებელია
            </span>
          )}
        </StorageStatusContainer>
      </MobileView>
      {product.sets.products ? (
        <CardContainer>
          <div className="flex flex-row gap-2 items-center justify-start mb-3">
            <img src="/img/gift.jpg" alt="gift" width={30} />
            <span className="font-bold" style={{ alignSelf: 'end' }}>
              საჩუქარი
            </span>
          </div>
          {product.sets.products.map((set, index) => (
            <div
              key={index}
              className="flex flex-row gap-2 items-center justify-start mb-3  text-sm"
            >
              <a href={'/product/' + set.slug}>- {set.name}</a>
            </div>
          ))}
        </CardContainer>
      ) : null}

      <BrowserView>
        {!inStock ? (
          <StorageStatusContainer>
            <span className="out-of-stock mt-4">
              <NoStock />
              არ არის მარაგში
            </span>
          </StorageStatusContainer>
        ) : null}
        <CardContainer>
          <div class="flex items-center space-x-2">
            <img
              src={'/img/citrus-shop.png'}
              className={'max-w-[45px] h-auto w-full shrink-0'}
              alt={'citrus shop'}
            />
            <p className={'text-sm text-[#5c6772]'}>
              <span className={'!font-extrabold text-black'}>
                ფიზიკური მაღაზიის მისამართი:
              </span>
              <br />
              თბილისი, ალ. ყაზბეგის გამზირი 2ა
            </p>
          </div>
        </CardContainer>
      </BrowserView>
    </StyledProductPrice>
  )
}
